
import React, { useState, useEffect, useContext } from "react";
import quizThumb from '../../assets/images/quiz-default.jpg';
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useHistory, Link, useLocation } from "react-router-dom";
import moment from "moment";

const Register = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { flag } = state || {};
    const [quizData, setQuizData] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        emailid: "",
        // phone: "",
        // designation: ""
    });
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);
    const [imageCloudfront, setImg] = useState(false);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    useEffect(() => {
        if (flag) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {
                event.preventDefault();
                history.push('/')

            };

            // Initially pushState to allow popstate to fire
            window.history.pushState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        let quizinfo = JSON.parse(localStorage.getItem('q'))
        if (quizinfo) {
            setQuizData(quizinfo)
        }
        let userinfo = JSON.parse(localStorage.getItem('u'))
        if (userinfo) {
            setFormData(userinfo)
        }
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    };

    const handleSubmit = (e) => {
        const isValid = formvalidation();
        if (isValid) {
            localStorage.setItem('u', JSON.stringify(formData))
            history.push({
                pathname: "/quiz",
                state: { quizinfo: quizData, formData }
            });
        }


    }


    function formvalidation() {
        let formIsValid = true;

        // console.log('form', formData)
        if (formData?.name == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "Please enter Name", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["name"]: "", // Update the changed field
            }));
        }



        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (formData?.emailid === "") {
            setError((prevData) => ({
                ...prevData,
                ["emailid"]: "Please enter email",
            }));
            seterrorDisplay(true);
            setTimeout(() => {
                seterrorDisplay(false);
            }, 3000);
            formIsValid = false;
        } else if (!emailRegex.test(formData?.emailid)) {
            setError((prevData) => ({
                ...prevData,
                ["emailid"]: "Please enter a valid email address",
            }));
            seterrorDisplay(true);
            setTimeout(() => {
                seterrorDisplay(false);
            }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["emailid"]: "", // Clear the error for the email field
            }));
        }
        // if (formData?.phone == "") {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["phone"]: "Please enter phone", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["phone"]: "", // Update the changed field
        //     }));
        // }

        // if (formData?.designation == "") {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["designation"]: "Please enter designation", // Update the changed field
        //     }));
        //     seterrorDisplay(true)
        //     setTimeout(function () { seterrorDisplay(false) }, 3000);
        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         ["designation"]: "", // Update the changed field
        //     }));
        // }

        return formIsValid;
    }

    const handleBack = (e) => {
        history.push("/");
    }

    //    console.log('quizData' , quizData, quizinfo)
    return (
        <main>
            <Header />
            <div className="form_block">
                <div className="wrp">
                    <div className="quiz_info">
                        <div className="img">
                            {quizData?.files && quizData?.files.length > 0 ?
                                <img src={imageCloudfront + quizData?.files[0]?.filepath.replace(/ /g, "%20")} />
                                : <img src={quizThumb} />}



                        </div>
                        <div className="left">
                            <h3>{quizData?.name}</h3>
                            <div className="date">
                                <p>{quizData?.startDate && moment(new Date(quizData?.startDate)).format('DD MMM, YYYY')}</p>
                                <span className="users"><span className="material-symbols-outlined icon"> group </span><span className="num">{quizData?.participants || 0}</span></span>
                            </div>
                        </div>
                    </div>
                    <div className="form">
                        <h3 className="sub_title">Let's get started</h3>
                        <div className="form-group">
                            <label>Name <span>*</span></label>
                            <input type="text" name="name" className="form-control" placeholder="Enter Name" onChange={handleChange} value={formData?.name} />
                            {errorDisplay && <span className="errormsg" style={{
                                fontWeight: 'bold',
                                color: 'red',
                            }}>{errorData?.name}</span>}
                        </div>
                        <div className="form-group">
                            <label>Email <span>*</span></label>
                            <input type="text" name="emailid" className="form-control" placeholder="Enter email" onChange={handleChange} value={formData?.emailid} />
                            {errorDisplay && <span className="errormsg" style={{
                                fontWeight: 'bold',
                                color: 'red',
                            }}>{errorData?.emailid}</span>}
                        </div>
                        <div className="form-group">
                            <label>Phone Number</label>
                            <input type="text" name="phone" className="form-control" placeholder="Enter Phone" onChange={handleChange} value={formData?.phone} />

                        </div>
                        <div className="form-group">
                            <label>Designation</label>
                            <input type="text" name="designation" className="form-control" placeholder="Enter Designation" onChange={handleChange} value={formData?.designation} />
                            {/* {errorDisplay && <span className="errormsg" style={{
                                fontWeight: 'bold',
                                color: 'red',
                            }}>{errorData?.designation}</span>} */}
                        </div>
                        <div className="btns">
                            <button onClick={(e) => handleSubmit(e)} type="submit" class="vs_btn mr-10">Get Started</button>
                            <button onClick={(e) => handleBack(e)} type="submit" class="border_btn">Cancel</button>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default Register;
